import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var LigatureLevel = /** @class */ (function (_super) {
    __extends(LigatureLevel, _super);
    function LigatureLevel() {
        return _super.call(this) || this;
    }
    LigatureLevel.forceNativeConstructor = true;
    LigatureLevel.forceNativeMethods = true;
    // JS -> AS Bindings
    LigatureLevel.NONE = 'none';
    LigatureLevel.MINIMUM = 'minimum';
    LigatureLevel.COMMON = 'common';
    LigatureLevel.UNCOMMON = 'uncommon';
    LigatureLevel.EXOTIC = 'exotic';
    return LigatureLevel;
}(ASObject));
export { LigatureLevel };
